import { Component, Input } from "@angular/core";
import { ChevronIconDirection } from "./chevron-icon";

@Component({
    standalone: true,
    selector: "gene-chevron-icon",
    templateUrl: "./chevron-icon.component.html",
    styleUrls: ["./chevron-icon.component.css"],
})
export class ChevronIconComponent {
    @Input() width!: string;
    @Input() height!: string;
    @Input() color!: string;
    @Input() direction: ChevronIconDirection = "down";
}
